// extracted by mini-css-extract-plugin
export default {"artists":"DetailForm_artists__JJHlK","artist":"DetailForm_artist__WJ+ub"};